module.exports = __webpack_public_path__ + "img/03.418f1293.png";